import { createApi } from '@/api/modules/utils'

const baseUrl = '/account/role'
const api = createApi(baseUrl)

export const roleApi = {
  list: api('list', 'get'),
  insert: api('insert', 'post'),
  update: api('update', 'post'),
  delete: api('delete', 'get'),
  menuTree: api('menu_tree', 'get'),
}
